module.exports = __webpack_public_path__ + "img/handshake@2x.d41ed0b7.png";